import { MonthYear } from './monthYear';

export interface MonthYearValue {
  value: number;
  date: MonthYear;
}

export const sumOfMonthYearArrayValues = (data: MonthYearValue[]): number => {
  return data.reduce((acc, currentValue) => acc + currentValue.value, 0);
};

// Function to group data by year
export const groupDataByYear = (data: MonthYearValue[]) => {
  return data.reduce((acc, currentValue) => {
    const year = currentValue.date.year;
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(currentValue);
    return acc;
  }, {} as Record<number, MonthYearValue[]>);
};

// Function to reverse the grouping by year, converting a Record<number, MonthYearValue[]> back to MonthYearValue[]
export const flattenDataByYear = (groupedData: Record<number, MonthYearValue[]>): MonthYearValue[] => {
  let flatArray: MonthYearValue[] = [];
  for (const year in groupedData) {
    flatArray = flatArray.concat(groupedData[year]);
  }
  return flatArray;
};

export function findHighestValueInDictionary(data: Record<number, MonthYearValue[]>): number {
  let highest = -Infinity; // Start with the smallest possible number
  for (const key in data) {
    const yearData = data[key];
    const maxInYear = Math.max(...yearData.map((item) => item.value)); // Find max in each year
    if (maxInYear > highest) {
      highest = maxInYear; // Update if current year's max is higher
    }
  }
  return highest;
}

// Creates a MonthYearValue from specified date (or current date if not specified) and sets the value to DueDate
export const CreateCalenderAndAssignValueToDueDate = (
  value: number,
  dueDate: MonthYear,
  startDate?: MonthYear,
): MonthYearValue[] => {
  const currentDate = new Date();
  const currentMonth = startDate ? startDate.month : currentDate.getMonth() + 1;
  const currentYear = startDate ? startDate.year : currentDate.getFullYear();
  const monthYearValues: MonthYearValue[] = [];

  // Loop through each year from the current year to the due date year
  for (let year = currentYear; year <= dueDate.year; year++) {
    const startMonth = year === currentYear ? currentMonth : 1; // Start from the current month if it's the current year
    const endMonth = year === dueDate.year ? 12 : 12; // Always loop to December unless it's the due date year

    // Loop through each month from startMonth to endMonth
    for (let month = 1; month <= 12; month++) {
      if (month >= startMonth && month <= endMonth) {
        // Check if it's the due date month and year
        if (dueDate.month === month && dueDate.year === year) {
          monthYearValues.push({ value: value, date: { month, year } });
        } else {
          monthYearValues.push({ value: 0, date: { month, year } });
        }
      } else if (year === currentYear && month < currentMonth) {
        // If it's the current year and month is before the current month, set to 0
        monthYearValues.push({ value: 0, date: { month, year } });
      }
    }
  }

  return monthYearValues;
};

//temp function to add mock data
export const createMonthYearValues = (
  startMonth: number,
  endMonth: number,
  year: number,
  value: number,
): MonthYearValue[] => {
  const monthYearValues: MonthYearValue[] = [];

  for (let month = startMonth; month <= endMonth; month++) {
    monthYearValues.push({
      value: value,
      date: {
        month: month,
        year: year,
      },
    });
  }

  return monthYearValues;
};
export const sumOfMonthYearValue = (data: MonthYearValue[]): number => data.reduce((acc, item) => acc + item.value, 0);

export const getHighestAbsoluteValue = (data: MonthYearValue[]): number => {
  return data && data.length > 0 ? Math.max(...data.map(({ value }) => value)) : 1000;
};

export const getMaxValue = (materialPayments: Record<string, { exposureCalendar: [] }>): number =>
  getHighestAbsoluteValue(Object.values(materialPayments)?.[0]?.exposureCalendar || []);
